// Single source of truth for bootstrap admin accounts.
// Keep in sync with the hardcoded list in firestore.rules (search: "knownAdminEmails").
// These emails bypass the normal role-document lookup during initial setup only.
export const KNOWN_ADMIN_EMAILS = [
  'admin@npigovernancesolutions.com',
  'admin@npigovernance.co.za',
  'giftzikalala67@gmail.com',
  'developer@osindustries.co.za',
  'menzin@gabanegroup.com'
];
